var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-plotly',{attrs:{"data":_vm.chartData,"layout":Object.assign({}, _vm.chartLayout, {annotations: _vm.chartAnnotations}),"options":_vm.chartOptions,"config":{ responsive: true }},on:{"hover":_vm.hoveredData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }